var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 3956,
    viewBox: "0 0 1920 3956",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2344",
    "data-name": "Group 2344",
    transform: "translate(0 -89)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_376",
    "data-name": "Line 376",
    y1: 2164,
    transform: "translate(865 337.5)",
    fill: "none",
    stroke: "#d6d6d6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_377",
    "data-name": "Line 377",
    y1: 1329,
    transform: "translate(1666 89)",
    fill: "none",
    stroke: "#d6d6d6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_379",
    "data-name": "Line 379",
    x1: 1014,
    transform: "translate(0 1230.5)",
    fill: "none",
    stroke: "#d6d6d6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_380",
    "data-name": "Line 380",
    y1: 1685,
    transform: "translate(1401.5 2360)",
    fill: "none",
    stroke: "#d6d6d6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_378",
    "data-name": "Line 378",
    x1: 1920,
    transform: "translate(0 120)",
    fill: "none",
    stroke: "#d6d6d6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_419",
    "data-name": "Line 419",
    x2: 1920,
    transform: "translate(0 2501.5)",
    fill: "none",
    stroke: "#d6d6d6",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLines);
export default __webpack_public_path__ + "static/media/BgLines.961d575b70df7e588326bd0a707bb140.svg";
export { ForwardRef as ReactComponent };